import {ListBalance} from 'organization/Event/Earning/ListBalance'
import BreadcrumMenu from 'organization/theme/Breadcrum'
import React from 'react'
import styled from 'styled-components'
import {Pagination} from '@mui/material'
import {OrgFaqHelp} from 'organization/Help/FAQ'
import {InvoiceIssue} from 'organization/Earning/InvoiceIssue'
import {useEarning} from 'organization/Earning/EarningProvider'
import OrganizationPage from 'organization/theme/OrganizationPage'
import {useEarningInvoice} from 'organization/Earning/EarningInvoiceProvider'
import {useI18n} from 'i18n/I18nContext'

export const OrganizationEarning = () => {
  const {t} = useI18n()
  const {totalProfit, balance, totalPages, page, changePage} = useEarning()
  const {payoutPreview} = useEarningInvoice()

  return (
    <OrganizationPage>
      <>
        <div className="row pl-30 pb-30 pr-30">
          <BreadcrumMenu
            title={t('org.menu.earnings')}
            helpInfo={<OrgFaqHelp faqKey="earnings" />}
          />

          <InvoiceIssue />

          <div className="col-12">
            <div className="create__event-area">
              <div className="body__card-wrapper attendant__wrapper">
                <MainInfoHolder>
                  <div>
                    <p style={{fontSize: '1.5rem'}}>
                      {t('orgEarnings.totalRevenue')}{' '}
                      <b>{totalProfit.toFixed(2)} €</b>
                    </p>

                    <p style={{fontSize: '1.5rem'}}>
                      {t('orgEarnings.availablePayout')}{' '}
                      <b>{payoutPreview.invoiceTotal.toFixed(2)} €</b>
                    </p>
                    {payoutPreview.implicitVatDeductedPercent != null && (
                      <p
                        style={{
                          fontSize: '0.95rem',
                          color: '#666',
                          marginTop: 6,
                          maxWidth: 560,
                          lineHeight: 1.45,
                        }}
                      >
                        {t('orgEarnings.vatNetNote')
                          .replace(
                            '{pct}',
                            String(payoutPreview.implicitVatDeductedPercent),
                          )
                          .replace(
                            '{gross}',
                            payoutPreview.grossPayout.toFixed(2),
                          )}
                      </p>
                    )}

                    <b>{t('orgEarnings.payoutDelayNote')}</b>
                  </div>
                </MainInfoHolder>

                <table>
                  <thead>
                    <tr>
                      <th>{t('orgTable.colNo')}</th>
                      <th>{t('orgTable.colDate')}</th>
                      <th>{t('orgTable.colType')}</th>
                      <th>{t('orgTable.colTicketTier')}</th>
                      <th>{t('orgTable.colDescription')}</th>
                      <th>{t('orgTable.colAmount')}</th>
                      <th>{t('orgTable.colPlatformFee')}</th>
                      <th>{t('orgTable.colYourShare')}</th>
                      <th>{t('orgTable.colStatus')}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {balance.length === 0 && (
                      <tr>
                        <td colSpan={9}>{t('orgTable.empty')}</td>
                      </tr>
                    )}
                    {balance &&
                      balance.map((item, index) => (
                        <ListBalance balance={item} index={index} />
                      ))}
                  </tbody>
                </table>

                <PaginationHolder>
                  <Pagination
                    count={totalPages}
                    shape="rounded"
                    page={page}
                    onChange={changePage}
                  />
                </PaginationHolder>
              </div>
            </div>
          </div>
        </div>
      </>
    </OrganizationPage>
  )
}

const MainInfoHolder = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid var(--clr-border-1);
  padding-bottom: 40px;
  margin-bottom: 20px;
`

const PaginationHolder = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 30px;
`
